module.exports = __webpack_public_path__ + "static/media/splash.2b28464c.png";